import { api } from "@/lib/api";

export type LabReportScope = "ALL" | "OPD" | "IPD" | "DAYCARE";

export const labReportsApi = {
  summary: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get<{ message: string; data: any }>("/api/lab/reports/summary", { params }),

  summaryCsv: async (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get("/api/lab/reports/summary", {
      params: { ...params, format: "csv" },
      responseType: "blob",
    }),

  patientWise: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get<{ message: string; data: { rows: any[] } }>("/api/lab/reports/patient-wise", { params }),

  patientWiseCsv: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get("/api/lab/reports/patient-wise", {
      params: { ...params, format: "csv" },
      responseType: "blob",
    }),

  testsMostUsed: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get<{ message: string; data: { rows: any[] } }>("/api/lab/reports/tests-most-used", { params }),
  testsMostUsedCsv: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get("/api/lab/reports/tests-most-used", { params: { ...params, format: "csv" }, responseType: "blob" }),

  vendorWise: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get<{ message: string; data: { rows: any[] } }>("/api/lab/reports/vendor-wise", { params }),
  vendorWiseCsv: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get("/api/lab/reports/vendor-wise", { params: { ...params, format: "csv" }, responseType: "blob" }),

  revenueCuts: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get<{ message: string; data: { rows: any[] } }>("/api/lab/reports/revenue-cuts", { params }),
  revenueCutsCsv: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get("/api/lab/reports/revenue-cuts", { params: { ...params, format: "csv" }, responseType: "blob" }),

  labPayout: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get<{ message: string; data: any }>("/api/lab/reports/lab-payout", { params }),

  labPayoutPatientWiseCsv: (params: { from: string; to: string; scope?: LabReportScope; hospitalId?: string }) =>
    api.get("/api/lab/reports/lab-payout/patient-wise", {
      params: { ...params, format: "csv" },
      responseType: "blob",
    }),
};

